import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["onChange", "ref"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Flex, RadioGroup, Stack, Text } from '@chakra-ui/react';
import { useSemanticTypography } from '@whitbread-eos/utils';
import { Controller } from 'react-hook-form';
import RadioButton, { PaymentRadioButton } from '../../Radio';
import FormError from '../FormError';
import { FORM_VALIDATIONS } from '../formConstants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function FormRadioGroup(_ref) {
  var _formField$props, _formField$props2, _formField$props4;
  var control = _ref.control,
    formField = _ref.formField,
    errors = _ref.errors,
    handleSetValue = _ref.handleSetValue,
    onChangeAction = _ref.onChangeAction;
  var getTypographyProps = useSemanticTypography();
  var horizontalRadioButtons = formField === null || formField === void 0 || (_formField$props = formField.props) === null || _formField$props === void 0 ? void 0 : _formField$props.horizontalRadioButtons;
  var WrapperComponent = horizontalRadioButtons ? PaymentRadioButton : RadioButton;
  return _jsxs(Flex, _objectSpread(_objectSpread({
    direction: "column"
  }, _objectSpread(_objectSpread({}, defaultStyles), formField.styles)), {}, {
    "data-testid": formField.testid,
    "data-fieldname": formField.name,
    children: [(formField === null || formField === void 0 || (_formField$props2 = formField.props) === null || _formField$props2 === void 0 ? void 0 : _formField$props2.errorLocation) === FORM_VALIDATIONS.FORM_FIELD_ERROR_LOCATION.ON_TOP && _jsx(FormError, {
      errors: errors,
      name: formField.name,
      extraStyles: {
        containerStyle: {
          marginBottom: 'md'
        },
        textStyle: {
          marginTop: 0,
          marginLeft: 0
        }
      }
    }), _jsx(Controller, {
      name: formField.name,
      control: control,
      render: _ref2 => {
        var _formField$props3, _formField$options;
        var field = _ref2.field;
        var _onChange = field.onChange,
          _ = field.ref,
          extraPropsField = _objectWithoutProperties(field, _excluded);
        return _jsx(RadioGroup, _objectSpread(_objectSpread({
          onChange: value => {
            var _formField$onChange;
            (_formField$onChange = formField.onChange) === null || _formField$onChange === void 0 || _formField$onChange.call(formField, value);
            _onChange(value);
            onChangeAction === null || onChangeAction === void 0 || onChangeAction(value, handleSetValue);
          }
        }, extraPropsField), {}, {
          children: _jsx(Stack, _objectSpread(_objectSpread({}, (formField === null || formField === void 0 || (_formField$props3 = formField.props) === null || _formField$props3 === void 0 ? void 0 : _formField$props3.horizontalRadioButtons) && _objectSpread({}, horizontalRadioContainerStyles)), {}, {
            spacing: "0",
            direction: "column",
            style: {
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0
            },
            children: (_formField$options = formField.options) === null || _formField$options === void 0 ? void 0 : _formField$options.map((option, listIndex) => {
              var _formField$options2;
              var isLastInList = listIndex === Number((_formField$options2 = formField.options) === null || _formField$options2 === void 0 ? void 0 : _formField$options2.length) - 1;
              var isChecked = field.value === option.value;
              var optionLabelLegacyTypography = {
                fontWeight: isChecked || horizontalRadioButtons ? 'semibold' : 'normal'
              };
              var optionLabelSemanticTypography = {
                textStyle: isChecked || horizontalRadioButtons ? 'body-m-emphasis' : 'body-m-regular'
              };
              return _jsx(WrapperComponent, {
                name: option.value,
                listIndex: isLastInList ? 'last' : 0,
                value: option.value,
                isChecked: isChecked,
                "data-testid": option.testid,
                children: option.Component ? _jsx(option.Component, {
                  isChecked: isChecked
                }) : _jsx(Text, _objectSpread(_objectSpread({}, getTypographyProps(optionLabelLegacyTypography, optionLabelSemanticTypography)), {}, {
                  children: option.label
                }))
              }, "".concat(formField.name, "-").concat(listIndex));
            })
          }))
        }));
      }
    }), !(formField !== null && formField !== void 0 && (_formField$props4 = formField.props) !== null && _formField$props4 !== void 0 && _formField$props4.errorLocation.length) && _jsx(FormError, {
      errors: errors,
      name: formField.name,
      extraStyles: formField.errorStyles
    })]
  }));
}
var defaultStyles = {
  marginBottom: 'var(--chakra-space-md)'
};
var horizontalRadioContainerStyles = {
  flexDirection: {
    mobile: 'column',
    lg: 'row'
  }
};